exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".book{position:fixed;width:100vw;height:100vh;z-index:11;background-color:hsla(0,0%,93%,.8)}@media only screen and (max-width:768px){.book{position:fixed;min-height:100vh;width:100vw;z-index:11;overflow-y:scroll;background-color:#fff}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/home/book/book.scss
// module id = 775
// module chunks = 0